import {useState} from 'react';
import {Banner, BlockStack, Button, Modal, Text} from '../components/admin-ui';
import {QuestionCircleIcon} from '../components/admin-ui/icons';
import CodVerificationSettings from '../components/CodVerificationSettings';
import storageUtils from '../utils/storageUtils';
import {t, useLocale} from '../localization/adminText';
import './OrderVerification.css';
import CodVerificationContent from '../components/CodVerificationContent';
import {Card} from '../components/admin-ui';

export default function OrderVerification() {
  useLocale();
  const userToken = storageUtils.get('user_token');
  const [helpOpen, setHelpOpen] = useState(false);
  return <main className="verification-admin">
    <header className="verification-page-header">
      <Text as="p" tone="subdued">{t('Verify buyer contact details before a COD order is placed.')}</Text>
      <Button variant="plain" icon={QuestionCircleIcon} onClick={()=>setHelpOpen(true)}>{t('How it works')}</Button>
    </header>
    {!userToken ? <Banner tone="critical">{t('Store login token is missing.')}</Banner> :
      <div className="verification-sections"><CodVerificationSettings userToken={userToken}/><Card><CodVerificationContent userToken={userToken}/></Card></div>}
    <Modal open={helpOpen} onClose={()=>setHelpOpen(false)} title={t('Order verification')}>
      <Modal.Section><BlockStack gap="400">
        <Text as="p">{t('Require a code before a COD order is placed. Buyers may use any enabled method. Email verification confirms the email address only. Existing order restrictions are checked before sending a code.')}</Text>
        <Text as="p">{t('Verification confirms access to a contact method. It does not guarantee delivery acceptance.')}</Text>
        <Text as="p">{t('Requests are at least 60 seconds apart. The request that reaches the limit sends no code and pauses verification for 15 minutes. For example, a limit of 3 allows two sends; the third request pauses verification. Four incorrect codes add an anomaly reminder; five pause verification. These events do not add customers to the shared blacklist.')}</Text>
      </BlockStack></Modal.Section>
    </Modal>
  </main>;
}
